import { FC, ReactNode } from 'react'
import cn from './index.module.css'
import classNames from 'classnames'

interface IFieldWrapper {
  label?: string
  children: ReactNode
  extraContent?: ReactNode
  isInvalid?: boolean
  className?: string
}

const FieldWrapper: FC<IFieldWrapper> = ({
  children,
  label,
  isInvalid,
  extraContent,
  className,
}) => {
  return (
    <div className={classNames(cn.wrapper, className)}>
      {(label || extraContent) && (
        <div className={cn.header}>
          <span className={classNames(cn.label, isInvalid && cn.invalid)}>
            {label}
          </span>
          {extraContent}
        </div>
      )}
      {children}
    </div>
  )
}

export default FieldWrapper
